import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { HomePage } from "./pages/Home";
import { ResourcesPage } from "./pages/Resources";
import { ContactPage } from "./pages/Contact";
import { ParentingSupportPage } from "./pages/services/ParentingSupport";
import { FamilyTherapyPage } from "./pages/services/FamilyTherapy";
import { ChildAdolescentPage } from "./pages/services/ChildAdolescent";
import { AnxietyDepressionPage } from "./pages/services/AnxietyDepression";
import { TraumaPTSDPage } from "./pages/services/TraumaPTSD";
import { AdoptionSupportPage } from "./pages/services/AdoptionSupport";
import { Toaster } from "./components/ui/sonner";
import "./App.css";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/resources" element={<ResourcesPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/services/parenting-support" element={<ParentingSupportPage />} />
              <Route path="/services/family-therapy" element={<FamilyTherapyPage />} />
              <Route path="/services/child-adolescent" element={<ChildAdolescentPage />} />
              <Route path="/services/anxiety-depression" element={<AnxietyDepressionPage />} />
              <Route path="/services/trauma-ptsd" element={<TraumaPTSDPage />} />
              <Route path="/services/adoption-support" element={<AdoptionSupportPage />} />
            </Routes>
          </main>
          <Footer />
          <Toaster />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
